import { render } from "./AppLoader.vue?vue&type=template&id=1eee4709&scoped=true"
import script from "./AppLoader.vue?vue&type=script&lang=ts"
export * from "./AppLoader.vue?vue&type=script&lang=ts"

import "./AppLoader.vue?vue&type=style&index=0&id=1eee4709&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1eee4709"

export default script